<template>
    <div class="customer_group_add_wrap">
        <div class="header">
            <el-button size="medium" @click="goBack">返回</el-button>
            <el-button size="medium" type="primary" @click="saveGroup">保存</el-button>
        </div>
        <div class="customer_group_box" :style="`height: ${windowHeight - 180}px;`">
            <div class="customer_group_content">
                <el-form :model="formData" :rules="rules" ref="form" label-width="140px" class="demo-ruleForm">
                    <el-form-item label="客服组名称" prop="name">
                        <el-input v-model="formData.name" :minlength="1" :maxlength="10" placeholder="请输入客服组名称"></el-input>
                    </el-form-item>
                    <el-form-item label="客服组长" prop="leaderJson">
                        <address-book v-model="formData.leaderJson" :config="configLeaderData"></address-book>
                    </el-form-item>
                    <el-form-item label="组员" prop="memberJson">
                        <address-book v-model="formData.memberJson" :config="configMemberData"></address-book>
                    </el-form-item>
                </el-form>
            </div>
        </div>
    </div>
</template>

<script>
    import windowResize from '@/mixins/windowResize';
    import AddressBook from '@/components/AddressBook/indexExpand';
    import {detailGroup, addGroup, updateGroup} from '@/api/dealerManage';

    export default {
        name: "customerServiceGroupAdd",
        components: {
            AddressBook
        },
        data() {
            let validateAddress = (rule, value, callback) => {
                if (!value.userJson || !value.userJson.length) {
                    callback(new Error('请选择客服！'));
                } else {
                    callback();
                }
            };
            return {
                groupId: this.$route.query.groupId,
                configLeaderData: {
                    title: '选择客服组长',
                    depart: {target: 'user', departType: 't', userTypes: '1'},
                    SingleChose: true
                },
                configMemberData: {
                    title: '选择组员',
                    depart: {target: 'user', departType: 't', userTypes: '1'}
                },
                formData: {
                    name: '',
                    leaderJson: {userJson:[]},
                    memberJson: {userJson:[]}
                },
                rules: {
                    name: [
                        {required: true, trigger: 'blur', message: '请输入客服组名称'},
                        {min: 1, max: 10, message: "1~10个字符", trigger: "change"}
                    ],
                    leaderJson: [
                        {required: true, validator: validateAddress, trigger: 'input'}
                    ],
                    memberJson: [
                        {required: true, validator: validateAddress, trigger: 'input'}
                    ]
                }
            }
        },
        mixins: [windowResize],
        created() {
            if (this.groupId) this.detailGroup();
        },
        methods: {
            goBack() {
                this.$router.go(-1);
            },
            detailGroup() {
                detailGroup({groupId: this.groupId}).then(data => {
                    this.formData = {
                        name: data.name,
                        leaderJson: {userJson: [data.leader]},
                        memberJson: {userJson: data.members}
                    };
                })
            },
            saveGroup() {
                this.$refs.form.validate(isValid => {
                    if (isValid) {
                        const query = {
                            name: this.formData.name,
                            leaderId: this.formData.leaderJson.userJson[0].id,
                            memberIds: this.formData.memberJson.userJson.map(item => item.id).toString()
                        };

                        new Promise(resolve => {
                            if (this.groupId) {
                                query.id = this.groupId;
                                updateGroup(query).then(resolve)
                            } else {
                                addGroup(query).then(resolve)
                            }
                        }).then(() => {
                            this.$message.success(`${this.groupId ? '编辑' : '新增'}成功`);
                            window.setTimeout(() => {
                                this.goBack();
                            }, 500);
                        })
                    }
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
    @import './../../../styles/mixin';

    .customer_group_add_wrap {
        padding: 12px;

        .header {
            padding-bottom: 10px;
            border-bottom: 1px solid #eee;
        }

        .customer_group_box {
            @include scrollBar;

            .customer_group_content {
                width: 810px;
                margin: 0 auto;
                padding-top: 20px;

            }
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/dealerManage/customerService/customerServiceGroupAdd.vue